import { render } from "./RecentAttempts.vue?vue&type=template&id=69c21bac&scoped=true"
import script from "./RecentAttempts.vue?vue&type=script&lang=js"
export * from "./RecentAttempts.vue?vue&type=script&lang=js"

import "./RecentAttempts.vue?vue&type=style&index=0&id=69c21bac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69c21bac"]])

export default __exports__